export const testPhoneNumber = (number: string | undefined, prefix: string): boolean => {
  if (number === undefined) return true;

  const digitsWithPrefixCount = `${prefix}${number}`.replace(/[^\d]/g, '').length;

  return /^\d+$/.test(number) && digitsWithPrefixCount <= 15 && digitsWithPrefixCount >= 7;
};
